import isAppointment from "../../adressHelpers/taskKind";

/**
 * Returns YYYY-MM-DD in a fixed timezone (default Europe/Amsterdam).
 * Assembles the key from formatToParts so it does not depend on the locale's
 * string order (en-CA is ISO in browsers but MM/DD/YYYY in this Node env).
 */
export const toDayKeyInTimeZone = (dateLike, timeZone = "Europe/Amsterdam") => {
  if (!dateLike) return null;
  const d = dateLike.toDate ? dateLike.toDate() : new Date(dateLike);

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);

  const year = parts.find((p) => p.type === "year").value;
  const month = parts.find((p) => p.type === "month").value;
  const day = parts.find((p) => p.type === "day").value;

  return `${year}-${month}-${day}`;
};

/**
 * Calculates worked hours between two Firestore Timestamps / Dates
 */
export const hoursBetween = (startTs, endTs) => {
  if (!startTs || !endTs) return 0;

  const start = startTs.toDate ? startTs.toDate() : new Date(startTs);
  const end = endTs.toDate ? endTs.toDate() : new Date(endTs);

  const diffMs = end - start;
  if (!Number.isFinite(diffMs) || diffMs <= 0) return 0;

  return diffMs / (1000 * 60 * 60);
};

/**
 * Builds cumulative hours series from tasks
 *
 * Output:
 * [
 *   { day: '2026-01-22', hours: 3.5, cumulativeHours: 12.5 }
 * ]
 */
export const buildCumulativeHoursSeries = (
  tasks = [],
  timeZone = "Europe/Amsterdam"
) => {
  const hoursPerDay = new Map();

  tasks && tasks.forEach((task) => {
    // isAppointment, niet Type: de uren van een subtaak zijn geen bezoekuren.
    // AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
    if (!isAppointment(task)) return;

    const hours = hoursBetween(task.Timestamp, task.TimestampEnd);
    if (!hours) return;

    const dayKey = toDayKeyInTimeZone(task.Timestamp, timeZone);
    if (!dayKey) return;

    hoursPerDay.set(dayKey, (hoursPerDay.get(dayKey) || 0) + hours);
  });

  const sortedDays = Array.from(hoursPerDay.keys()).sort();

  let runningTotal = 0;

  return sortedDays.map((day) => {
    const dayHours = hoursPerDay.get(day) || 0;
    runningTotal += dayHours;

    return {
      day,
      hours: Number(dayHours.toFixed(2)),
      cumulativeHours: Number(runningTotal.toFixed(2)),
    };
  });
};